import React, { useState, forwardRef, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import PermissionChecker from '~/Classes/permissions'

const Tab = forwardRef((props, ref) => {
    const [menuOpen, setMenuOpen] = useState(false)
    const permissionStore = useSelector((state) => state.permission)
    const accountStore = useSelector((state) => state.accountMaster)
    const site = useSelector((state) => state.siteMaster)
    const history = useHistory()

    const itemClicked = (e, sub) => {
        e.preventDefault()
        e.stopPropagation()
        if (sub.route) {
            history.push(sub.route)
        } else if (sub.action && typeof sub.action === 'function') {
            sub.action()
        }
        setMenuOpen(false)
    }

    var classes = 'uiTab '
    if (props.isSelected) {
        classes += ' selected '
    }

    if (props.beta && accountStore.accountMaster.beta && !accountStore.accountMaster.beta[props.beta]) return null
    if (props.mpz && site.siteId !== 1) return null

    if (!props.permission || PermissionChecker(props.permission, permissionStore.permissions, 'read')) {
        const url = props.changeTab(props.tabId, true, true)
        const submenu = !!props.sub && !!props.sub.length && (
            <Fragment>
                <div className='uiTabSub-indicator' />
                <div className={'uiTabSub ' + (menuOpen ? 'open' : '')}>
                    {props.sub.map((sub, index) => {
                        if (sub.permission && sub.permission.name) {
                            if (permissionStore.permissions[sub.permission.name] !== sub.permission.value) return null
                        }
                        if (
                            sub.beta &&
                            accountStore.accountMaster.beta &&
                            !accountStore.accountMaster.beta[sub.beta]
                        )
                            return null
                        if (sub.mpz && site.siteId !== 1) return null
                        if (sub.divider) return <div key={index} className='uiTabSubDivider'></div>
                        const item = (
                            <>
                                {!!sub.icon && typeof sub.icon === 'string' && (
                                    <div className={sub.icon + ' uiTabSubIcon'}></div>
                                )}
                                {!!sub.icon && typeof sub.icon !== 'string' && (
                                    <div className={'uiTabSubIcon'}>{sub.icon}</div>
                                )}
                                <div className='uiTabSubText'>{sub.label}</div>
                                {!!sub.endIcon && <div className={'uiTabSubIconEnd'}>{sub.endIcon}</div>}
                            </>
                        )
                        if (sub.route) {
                            return (
                                <Link
                                    key={index}
                                    style={{ textDecoration: 'none' }}
                                    className='uiTabSubItem'
                                    to={sub.route}
                                    onClick={() => setMenuOpen(false)}
                                >
                                    {item}
                                </Link>
                            )
                        } else {
                            return (
                                <div key={index} className='uiTabSubItem' onClick={(e) => itemClicked(e, sub)}>
                                    {item}
                                </div>
                            )
                        }
                    })}
                </div>
            </Fragment>
        )
        const tabProps = {
            className: classes,
            ref: ref,
            onMouseEnter: () => setMenuOpen(true),
            onMouseLeave: () => setMenuOpen(false)
        }
        if (url) {
            return (
                <div {...tabProps}>
                    <Link
                        style={{
                            textDecoration: 'none',
                            color: 'inherit',
                            display: 'flex',
                            alignItems: 'center',
                            height: '100%'
                        }}
                        to={url}
                        onClick={(e) => {
                            if (url == window.location.pathname) {
                                e.preventDefault()
                                setMenuOpen(!menuOpen)
                            } else {
                                setMenuOpen(false)
                            }
                        }}
                    >
                        {props.label}
                    </Link>
                    {submenu}
                </div>
            )
        } else {
            return (
                <div {...tabProps} onClick={() => props.changeTab(props.tabId, true)}>
                    {props.label}
                    {submenu}
                </div>
            )
        }
    } else {
        return null
    }
})

export default Tab
